export default {
  resetCurrentCoordinates({ state }) {
    state.currentCoordinates = {
      longitude: null,
      latitude: null,
      accuracy: null
    }
  }
}